<template>
    <div class="u-color-3-dark" id="page-content">
        <section class="c-fold-split__wrap">
            <div class="o-color-change" data-logo-colors="logo-icon-is-color-3-dark, logo-text-is-color-3-dark, quick-nav-is-color-white, quick-nav-bg-is-transparent"></div>
            <div class="c-fold-split">
                <div class="o-grid -grid-flip-order">
                    <div class="o-grid-6">
                        <div class="c-fold-split__img">
                            <span class="o-responsive-img  " style="padding-top:106.45833333333%;"><img width="1440" height="1533"
                            src="/app/uploads/2024/02/img-fold-connexion.jpg" class="" alt="" loading="eager"
                            sizes="(max-width: 540px) 100vw, 50vw" decoding="async" fetchpriority="high"
                            srcset="/app/uploads/2024/02/img-fold-connexion.jpg 1440w, /app/uploads/2024/02/img-fold-connexion-1024x1090.jpg 1024w, /app/uploads/2024/02/img-fold-connexion-500x532.jpg 500w, /app/uploads/2024/02/img-fold-connexion-768x818.jpg 768w"></span>
                        </div>
                    </div>

                    <div class="o-grid-6 -grid-middle">
                        <div class="o-container">
                            <div class="c-fold-split__content">
                                <div class="o-form__wrap">
                                    <h1 class="o-title-5 c-fold-split__title">
                                        Connexion
                                    </h1>
                                    
                                    <div v-if="confirm.message" class="o-text c-fold-split__text"
                                        :class="{ '-error-form': confirm.state == 'error', '-success-form': confirm.state == 'success' }">
                                        <p>{{ confirm.message }}</p>
                                    </div>

                                    <form class="o-form" method="post" autocomplete="on" @submit.prevent="login" data-module="FocusLabel">
                                        <!-- data-module="FocusLabel" === le module ajoute une classe au parent du input avec focus,
                                        permet de garder le style du label qui flotte peu importe si le champ est requis ou non -->

                                        <div class="o-form__group">
                                            <input class="o-input" type="text" id="courriel" v-model="email" name="Courriel" required autocomplete="email">
                                            <label class="o-label" for="courriel">Courriel</label>
                                        </div>

                                        <div class="o-form__group">
                                            <input class="o-input" type="password" id="psw" name="psw" v-model="password" required autocomplete="current-password">
                                            <label class="o-label" for="psw">Mot de passe</label>
                                        </div>

                                        <div class="o-form__button">
                                            <div class="o-text o-form__note">
                                                <p><a :href="resetPasswordLink">Mot de passe oublié ?</a></p>
                                            </div>

                                            <button class="o-button -form-button" type="submit" aria-label="Soumettre le formulaire de connexion">
                                                <span class="o-button__text">Connexion</span>
                                                <span class="sr-only">Soumettre le formulaire de connexion</span>
                                                <svg aria-hidden="true" focusable="false" class="o-ico -icon-arrow-full-right">
                                                    <use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=225dad2b8cf35f8dfd#send"></use>
                                                </svg>
                                            </button>
                                        </div>

                                        <!--<div class="o-text o-form__note">
                                            <p>Vous n’avez pas de compte ?</p>
                                            <p><a :href="resetPasswordLink">Créer un compte</a></p>
                                        </div>-->
                                    </form>
                                    <div class="o-text u-pt-sm">
                                        <p>Une fois votre achat de laissez-passer effectué, vous pouvez accéder à votre compte en cliquant sur « connexion » ou « mot de passe oublié »</p>
                                        <a href="/tarifs-laissez-passer#form" target="_blank" class="o-button" aria-label="Acheter un laissez-passer">
                                            <span class="o-button__text">Achat de laissez-passer </span>
                                            <span class="sr-only">Acheter un laissez-passer</span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    </div>
</template>
<script>
import axios from 'axios'

export default {
    name: 'CustomerLogin',
    data() {
        return {
            email: '',
            password: '',
            confirm: {
                state: '',
                message: ''
            },
            resetPasswordLink: ''
        }
    },
    methods: {
        checkLogin() {
            this.resetPasswordLink = window.ajax_var.resetPassword;
            let params = {
                _wpnonce: window.ajax_var.nonce
            }
            axios.get('/wp-json/stereostore/v1/checklogin', { params })
                .then(response => {
                    if (response.data.ID != 0 && response.data.success) {
                        location.href = '/mon-compte/'
                    }
                })
                .catch(error => {
                    console.log(error)
                })
        },
        login() {
            let params = {
                email: this.email,
                password: this.password,
                token: this.$store.state.token,
                _wpnonce: window.ajax_var.nonce,
                redirect: '/mon-compte/'
            }
            axios.post('/wp-json/stereostore/v1/login', params)
                .then(response => {
                    this.confirm = {
                        state: 'success',
                        message: response.data.message
                    }
                    console.log(response.data.redirect_to)
                    location.href = response.data.redirect_to
                })
                .catch(error => {
                    this.confirm = {
                        state: 'error',
                        message: error.response.data.message
                    }
                })
        }
    },
    mounted() {
        this.checkLogin()
        //Remove all class starting with 'u-' on body
        document.body.className.split(' ').forEach(function (className) {
            if (className.match(/^u-/)) {
                document.body.classList.remove(className);
            }
        });
    }
}

</script>